import { MeaurementTypes } from '@models/measurements';
import { round } from 'lodash';

export const KILOFEET_IN_KILOMETER = 3.2808;
export const METER_IN_KILOMETER = 1000;
export const NS_IN_US = 1000;
export const FEET_IN_KFT = 1000;
export const METERS_IN_KM = 1000;
export const MILES_IN_KM = 1.609;
const PULSE_WIDTH_MULTIPLIER: number = 50;
const RESOLUTION_MULTIPLIER: number = 0.204;

export class MeasurementUtils {

    /**
     * Calculate the pulse width based on span length (in meters)
     *
     * @param spanLengthMeters span length in meters
     * @returns pulse width in nano seconds
     */
    static getPulseWidthFromSpanLength(spanLengthMeters: number): number {
        return spanLengthMeters / PULSE_WIDTH_MULTIPLIER;
    }

    /**
     * Calculate resolution base on pulse width
     *
     * @param pulseWidth pulse width in nano seconds
     * @returns resolution in meters
     */
    static getResolutionFromPulseWidth(pulseWidth: number): number {
        return pulseWidth * RESOLUTION_MULTIPLIER;
    }

    static convert(inputValue: number, inputType: MeaurementTypes, outputType: MeaurementTypes): number {
        if (inputType === outputType) {
            return inputValue;
        }

        switch (`${inputType}-to-${outputType}`) {
            case 'ns-to-us':
                return inputValue / NS_IN_US;
            case 'm-to-km':
                return round(inputValue / METER_IN_KILOMETER, 2);
            case 'km-to-m':
                return round(inputValue * METER_IN_KILOMETER, 2);
            case 'km-to-kft':
                return round(inputValue * KILOFEET_IN_KILOMETER, 2);
            case 'kft-to-km':
                return round(inputValue / KILOFEET_IN_KILOMETER, 2);
            case 'km-to-ml':
                return round(inputValue / MILES_IN_KM, 2);
            case 'ml-to-km':
                return inputValue * MILES_IN_KM;
            default:
                console.error('convert measurement input field or output field incorrect or undefined');
                return NaN;
        }
    }
}
